import type { PlatformDictionary } from '../types';

export const ukDictionary: PlatformDictionary = {
  languageName: 'Ukrainian',
  languageNativeName: 'Українська',
  layout: {
    defaultMetaTitle: 'Послуги, профілі та інсайти',
    defaultMetaDescription:
      'Знаходьте перевірених фахівців, порівнюйте послуги та читайте практичні матеріали в блозі Matcha Events.',
    builtWith: 'Працює на Next.js, TypeORM, PostgreSQL та Strapi.',
    headerStatsProfilesValue: 'Профілі',
    headerStatsProfilesTitle: 'Перевірені виконавці',
    headerStatsProfilesDescription:
      'Добирайте фахівців за експертизою, локацією та доступністю ще до першого контакту.',
    headerStatsServicesValue: 'Послуги',
    headerStatsServicesTitle: 'Активні пропозиції',
    headerStatsServicesDescription:
      'Порівнюйте обсяг робіт і моделі ціноутворення, щоб швидше обрати потрібний варіант.',
    headerStatsInsightsValue: 'Інсайти',
    headerStatsInsightsTitle: 'Практичні гайди',
    headerStatsInsightsDescription:
      'Читайте свіжі матеріали блогу, щоб краще планувати виконання та уникати типових помилок.',
    footerDescription: 'Знаходьте виконавців, послуги та практичні матеріали в одному місці.',
    footerColumnPlatform: 'Платформа',
    footerColumnResources: 'Ресурси',
    footerColumnLegal: 'Правова інформація',
    footerFaq: 'FAQ',
    footerTerms: 'Умови та положення',
    footerPrivacy: 'Політика конфіденційності',
  },
  localeSwitcher: {
    label: 'Мова',
  },
  nav: {
    profiles: 'Профілі',
    services: 'Послуги',
    admin: 'Адмін',
    blog: 'Блог',
    chat: 'Чат',
  },
  auth: {
    openAccountMenu: 'Відкрити меню акаунта',
    openSupport: 'Відкрити підтримку',
    supportTooltip: 'Відкрити сторінку підтримки',
    accountMenu: 'Меню акаунта',
    signedIn: 'Ви увійшли',
    notSignedIn: 'Ви не увійшли',
    switchAccount: 'Змінити акаунт',
    signOut: 'Вийти',
    signIn: 'Увійти',
    signUp: 'Зареєструватися',
    createAccount: 'Створити акаунт',
    subtitle: 'Увійдіть, щоб отримати доступ до захищених функцій платформи.',
    closeDialog: 'Закрити діалог автентифікації',
    closeButton: 'Закрити',
    modeLabel: 'Режим автентифікації',
    firstName: "Ім'я",
    lastName: 'Прізвище',
    identifier: 'Email або номер телефону',
    identifierPlaceholder: 'name@example.com або +380501234567',
    identifierHint: 'Використовуйте email або телефон у міжнародному форматі.',
    identifierInvalid: 'Введіть коректний email або номер телефону.',
    password: 'Пароль',
    passwordHintSignIn: 'Введіть пароль від вашого акаунта.',
    passwordHintSignUp: 'Мінімум 8 символів, щонайменше одна літера і одна цифра.',
    passwordTooShort: 'Пароль має містити щонайменше 8 символів.',
    passwordNeedsLetterAndNumber: 'Пароль має містити щонайменше одну літеру і одну цифру.',
    submitWaiting: 'Зачекайте...',
    authFailed: 'Не вдалося завершити автентифікацію.',
    missingToken: 'Автентифікація пройшла успішно, але токен доступу не повернуто.',
    appleCredentialMissing: 'Вхід через Apple не повернув ID токен.',
    appleLoadFailed: 'Не вдалося завантажити вхід через Apple. Спробуйте пізніше.',
    continueWithApple: 'Продовжити з Apple',
    googleCredentialMissing: 'Вхід через Google не повернув ID токен.',
    googleLoadFailed: 'Не вдалося завантажити вхід через Google. Спробуйте пізніше.',
    continueWithGoogle: 'Продовжити з Google',
  },
  authPage: {
    heroTitle: 'Вітаємо',
    heroDescription: 'Використовуйте ці форми, щоб увійти або створити новий акаунт.',
    signInHeading: 'Увійти',
    signInMissingFields: 'Потрібно ввести email/номер телефону та пароль.',
    signInSubmit: 'Увійти',
    signInSubmitting: 'Вхід...',
    signInFailed: 'Не вдалося увійти. Спробуйте ще раз.',
    tooManyAttempts: 'Забагато спроб. Спробуйте ще раз за {minutes} хв.',
    signUpHeading: 'Створити акаунт',
    signUpMissingFields: "Потрібно ввести ім'я, прізвище, email/номер телефону та пароль.",
    signUpSubmit: 'Зареєструватися',
    signUpSubmitting: 'Реєстрація...',
    signUpFailed: 'Не вдалося зареєструватися. Спробуйте ще раз.',
    rememberMe: "Запам'ятати мене",
    alreadyHaveAccount: 'Уже маєте акаунт?',
    noAccountYet: 'Ще не маєте акаунта?',
    agreePrefix: 'Я погоджуюся з',
    termsAndConditions: 'Умовами та положеннями',
    acceptTermsRequired: 'Потрібно погодитися з умовами та положеннями.',
    orDivider: 'або',
    cookieNotice:
      'Ми використовуємо cookie, щоб зберігати ваш вхід, запам’ятовувати налаштування та покращувати роботу адмін-панелі Matcha Events. Детальніше в',
  },
  common: {
    draft: 'Чернетка',
    noExcerpt: 'Опис поки що недоступний.',
    pricingOnRequest: 'Ціна за запитом',
    from: 'Від',
    per: 'За',
    marketplacePlatform: 'Маркетплейс-платформа',
    marketplaceProfiles: 'Профілі маркетплейсу',
    marketplaceServices: 'Послуги маркетплейсу',
    clearFilter: 'Скинути фільтр',
    backToHome: 'Назад на головну',
    posted: 'Опубліковано',
    published: 'Опубліковано',
    listedBy: 'Розмістив',
    noContent: 'Контент відсутній.',
    loading: 'Завантаження...',
    pagination: 'Пагінація',
    previous: 'Попередня',
    next: 'Наступна',
    first: 'Перша',
    last: 'Остання',
  },
  adminChrome: {
    homeBreadcrumb: 'Головна',
    dashboardBreadcrumb: 'Дашборд',
    eventsBreadcrumb: 'Події',
    messagesBreadcrumb: 'Повідомлення',
    servicesBreadcrumb: 'Послуги',
    positionsBreadcrumb: 'Позиції',
    accountFallback: 'Акаунт',
    profileFallback: 'Профіль',
    serviceFallback: 'Послуга',
    manageProfile: 'Керувати профілем',
    profilesLabel: 'Профілі',
    profilesLoading: 'Завантаження профілів...',
    profilesEmpty: 'Профілі відсутні.',
    addProfile: 'Додати профіль',
    createProfileDialogTitle: 'Додати профіль',
    createProfileTitlePlaceholder: 'Назва профілю',
    createProfileDescriptionPlaceholder: 'Опис (необов’язково)',
    createProfileValidation: 'Назва профілю має містити щонайменше 2 символи.',
    createProfileAccountMissing: 'Не вдалося визначити акаунт для створення профілю.',
    createProfileSubmit: 'Додати профіль',
    createProfileSubmitting: 'Створення профілю...',
    tableEntriesPerPage: 'записів на сторінці',
    tableSearchPlaceholder: 'Пошук...',
    tableShowingEntries: 'Показано від {start} до {end} з {total} записів',
    footerMadeWith: 'зроблено з',
    footerBy: 'від',
    footerForBetterEvents: 'для кращих подій',
    appDownloadBanner: 'Застосунок Matcha Events доступний для завантаження',
    appDownloadAppStore: 'App Store',
    appDownloadAppStoreCta: 'Завантажити в App Store',
    appDownloadGooglePlay: 'Google Play',
    appDownloadGooglePlayCta: 'Отримати в Google Play',
    summerPromoDismiss: 'Закрити банер',
    cancel: 'Скасувати',
  },
  createProfilePage: {
    heading: 'Створіть свій профіль',
    description: 'Створіть принаймні один профіль, щоб публікувати послуги та керувати ними.',
    titlePlaceholder: 'Назва профілю',
    descriptionPlaceholder: 'Опис (необов’язково)',
    submit: 'Створити профіль',
    submitting: 'Створення профілю...',
    titleValidation: 'Назва профілю має містити щонайменше 2 символи.',
    createFailed: 'Не вдалося створити профіль. Спробуйте ще раз.',
  },
  adminInputs: {
    searchCategoriesPlaceholder: 'Пошук категорій',
    searchCategoriesHelper: 'Введіть назву категорії й натисніть Enter',
    searchSkillsPlaceholder: 'Пошук навичок',
    searchSkillsHelper: 'Шукайте наявні навички або введіть нову й натисніть Enter',
    searchExclusionsPlaceholder: 'Додати вид роботи',
    searchExclusionsHelper: 'Оберіть навичку або введіть власне формулювання (до 60 символів) і натисніть Enter',
    relatedSkillsLoading: 'Завантаження навичок для вибраних категорій...',
    relatedSkillsTitle: 'Навички з вибраних категорій',
    searchLanguagesPlaceholder: 'Пошук мов',
    searchLanguagesHelper: 'Введіть назву мови й натисніть Enter',
    searchCityPlaceholder: 'Пошук міста',
    cityHelperDefault: 'Виберіть місто зі списку або почніть вводити для пошуку.',
    cityHelperNoApi: 'Виберіть місто зі списку або введіть його й натисніть Enter, щоб додати.',
    cityHelperUnavailable: 'Виберіть місто зі списку. Google autocomplete зараз недоступний.',
    googleFallbackDisabled:
      'Google autocomplete вимкнено. Додайте REACT_APP_GOOGLE_MAPS_API_KEY, щоб увімкнути підказки.',
    googleFallbackUnavailable:
      'Google autocomplete зараз недоступний. Ви все одно можете вводити значення вручну.',
  },
  adminProfileEditor: {
    unavailable: 'Деталі профілю недоступні.',
    slugTaken: 'Цей slug профілю вже зайнятий. Виберіть інший.',
    firstNameLabel: "Ім'я",
    firstNamePlaceholder: "Ім'я",
    lastNameLabel: 'Прізвище',
    lastNamePlaceholder: 'Прізвище',
    titleLabel: 'Назва',
    titlePlaceholder: 'Назва профілю',
    descriptionLabel: 'Опис',
    descriptionPlaceholder: 'Опис профілю',
    categoriesLabel: 'Категорії',
    skillsLabel: 'Навички',
    exclusionsLabel: 'Не розглядаю',
    exclusionInvalid: 'Пункт має містити до 60 символів, без посилань, згадок і номерів телефону.',
    exclusionSkillConflict: 'Навичка не може бути водночас серед навичок і в «Не розглядаю». Приберіть її з одного зі списків.',
    slugLabel: 'Slug профілю',
    slugTooltip: 'Публічний URL: /profiles/{slug}',
    slugPlaceholder: 'your-profile-slug',
    citiesLabel: 'Міста',
    coverageRadiusLabel: 'Радіус покриття (км)',
    coverageRadiusPlaceholder: '50',
    languagesLabel: 'Мови',
    contactsLabel: 'Контакти',
    addContact: 'Додати контакт',
    noContacts: 'Контактів ще немає. Додайте один або кілька контактів профілю.',
    contactEmailPlaceholder: 'name@example.com',
    contactPhonePlaceholder: '+380 50 123 45 67',
    contactDetailsPlaceholder: 'Контактні дані',
    socialLinksLabel: 'Соцмережі',
    addLink: 'Додати посилання',
    noLinks: 'Посилань ще немає. Додайте одне або кілька соціальних посилань профілю.',
    socialLinkPlaceholder: 'https://social-link.example',
    uploadAvatar: 'Завантажити аватар',
    uploadingAvatar: 'Завантаження...',
    saveChanges: 'Зберегти зміни',
    saving: 'Збереження...',
    deleteAction: 'Видалити',
    avatarUploadSizeLimit: 'Файл має бути не більшим за 50 МБ.',
    avatarUploaded: 'Аватар завантажено.',
    avatarFileType: 'Файл аватара має бути зображенням.',
    avatarMismatch: 'Завантажений аватар не відповідає активному профілю.',
    avatarUploadFailed: 'Не вдалося завантажити аватар. Спробуйте ще раз.',
    contactMissingValue: 'У кожному рядку контакту має бути значення.',
    contactUniqueType: 'Кожен тип контакту можна використовувати лише один раз.',
    socialMissingUrl: 'У кожному рядку соціального посилання має бути URL.',
    socialUniquePlatform: 'Кожну соціальну платформу можна використовувати лише один раз.',
    cityMissingValue: 'У кожному рядку міста має бути значення міста.',
    cityPlaceIdMissing: 'Вибирайте кожне місто з підказок, щоб воно містило коректний place ID.',
    cityDuplicate: 'Дублікати міст не дозволені.',
    titleValidation: 'Назва профілю має містити щонайменше 2 символи.',
    coverageRadiusValidation: 'Радіус покриття має бути цілим числом від 0 до 1000 км.',
    slugMin: 'Slug профілю має містити щонайменше 3 символи.',
    slugMax: 'Slug профілю має містити не більше 128 символів.',
    profileUpdated: 'Профіль оновлено.',
    profileUuidMissing: 'UUID профілю відсутній.',
    profileNotFound: 'Профіль не знайдено.',
    profileLoadFailed: 'Не вдалося завантажити деталі профілю.',
    profileUpdateFailed: 'Не вдалося оновити профіль. Спробуйте ще раз.',
    loadingProfile: 'Завантаження профілю...',
    profileCardFallbackTitle: 'Профіль',
    profileCardFallbackSubtitle: 'Профіль послуги',
    profileAvatarAlt: 'Аватар профілю',
  },
  adminServiceEditor: {
    createTitle: 'Створити послугу',
    updateTitle: 'Оновити послугу',
    updateDescription: 'Редагуйте деталі послуги на окремій сторінці.',
    loading: 'Завантаження послуги...',
    notFound: 'Послугу не знайдено.',
    loadFailed: 'Не вдалося завантажити послугу. Спробуйте ще раз.',
    titleLabel: 'Назва',
    titlePlaceholder: 'Назва послуги',
    slugLabel: 'Slug послуги',
    slugTooltip:
      'Slug - це публічна частина URL цієї послуги (останній сегмент у /profiles/{profileSlug}/services/{serviceSlug}). Використовуйте малі літери, цифри та дефіси.',
    slugPlaceholder: 'Slug послуги (необовʼязково)',
    descriptionLabel: 'Опис',
    descriptionPlaceholder: 'Повний опис для сторінки послуги (800-1200 слів)',
    shortDescriptionLabel: 'Короткий опис',
    shortDescriptionPlaceholder: 'Короткий опис для картки послуги (20-40 слів)',
    seoDescriptionLabel: 'SEO-опис',
    seoDescriptionPlaceholder: 'SEO-опис (150-160 символів)',
    pricingModeLabel: 'Модель ціни',
    currencyLabel: 'Валюта',
    pricingModeFixed: 'Фіксована',
    pricingModeFrom: 'Від',
    pricingModeRange: 'Діапазон (мін/макс)',
    priceLabel: 'Ціна',
    fromPriceLabel: 'Ціна від',
    minimumPriceLabel: 'Мінімальна ціна',
    pricePlaceholder: 'Ціна',
    fromPricePlaceholder: 'Починаючи від',
    minimumPricePlaceholder: 'Мінімальна ціна',
    maximumPriceLabel: 'Максимальна ціна',
    maximumPricePlaceholder: 'Максимальна ціна',
    unitLabel: 'Одиниця (необовʼязково)',
    unitNone: 'Немає',
    unitHour: 'За годину',
    unitDay: 'За день',
    unitWeek: 'За тиждень',
    unitMonth: 'За місяць',
    unitSession: 'За сесію',
    unitItem: 'За одиницю',
    unitCustom: 'Власна',
    customUnitPlaceholder: 'Власна одиниця (наприклад, за м2)',
    mediaLabel: 'Медіа',
    addMediaEmpty: 'Додайте медіа до цієї послуги.',
    addMediaAction: 'Додати медіа',
    rehostFromLink: 'Перенести за посиланням',
    removeMediaAria: 'Видалити медіа',
    altTextPlaceholder: 'Alt-текст',
    altTextAria: 'Alt-текст для {fileName}',
    addMediaDialogTitle: 'Додати медіа',
    mediaSourceLabel: 'Джерело',
    mediaSourceFiles: 'Завантажити файли',
    mediaSourceUrl: 'Перенести за посиланням',
    mediaUrlPlaceholder: 'https://youtube.com/watch?v=...',
    mediaUrlHelper: 'Вставте URL медіа, щоб завантажити його та зберегти у вашому сховищі.',
    mediaTypeUrlLabel: 'Тип медіа (необовʼязково)',
    mediaTypeFallbackLabel: 'Тип медіа для невизначених файлів',
    mediaTypePlaceholder: 'Оберіть тип медіа',
    mediaTypeImage: 'Зображення',
    mediaTypeVideo: 'Відео',
    mediaTypeMusic: 'Музика',
    mediaTypeFile: 'Файл',
    selectedUrlTemplate: 'Вибраний URL: {value}',
    selectedUrlEmpty: 'Вкажіть URL медіа для перенесення.',
    selectedFileTemplate: 'Вибраний файл: {value}',
    selectedFilesTemplate: 'Вибрано файлів: {count}',
    detectedMediaTypeTemplate: 'Визначено тип медіа: {types}.',
    detectedMediaTypesTemplate: 'Визначено типи медіа: {types}.',
    undetectedMediaFileTemplate: 'Не вдалося визначити тип медіа для 1 файлу.',
    undetectedMediaFilesTemplate: 'Не вдалося визначити тип медіа для {count} файлів.',
    addMediaSubmit: 'Додати медіа',
    addMediaSubmitting: 'Додавання...',
    rehostMediaSubmit: 'Перенести медіа',
    rehostMediaSubmitting: 'Перенесення...',
    mediaDeleteDialogTitle: 'Видалити медіа',
    mediaDeleteDialogDescription:
      'Ви впевнені, що хочете видалити {title}? Цю дію неможливо скасувати.',
    mediaDeleteDialogFallbackTitle: 'цей медіафайл',
    mediaDeleteDialogConfirm: 'Видалити',
    mediaDeleteInProgress: 'Видалення...',
    saveChanges: 'Зберегти зміни',
    saving: 'Збереження...',
    cancel: 'Скасувати',
    createSubmit: 'Створити',
    createSubmitting: 'Створення...',
    titleValidation: 'Назва послуги має містити щонайменше 2 символи.',
    slugMin: 'Slug послуги має містити щонайменше 3 символи.',
    slugMax: 'Slug послуги має містити не більше 128 символів.',
    shortDescriptionMax: 'Короткий опис має містити не більше 280 символів.',
    seoDescriptionMax: 'SEO-опис має містити не більше 320 символів.',
    priceValidation: '{label} має бути коректним числом, не меншим за 0.',
    maximumPriceValidation: 'Максимальна ціна має бути коректним числом, не меншим за 0.',
    maximumPriceRangeValidation:
      'Максимальна ціна має бути більшою або дорівнювати мінімальній ціні.',
    customUnitRequired: 'Власна одиниця обовʼязкова, коли вибрано власний тип одиниці.',
    customUnitInvalid: 'Власну одиницю можна вказати лише для власного типу одиниці.',
    createFailed: 'Не вдалося створити послугу. Спробуйте ще раз.',
    updateFailed: 'Не вдалося оновити послугу. Спробуйте ще раз.',
    slugTaken: 'Цей slug послуги вже зайнятий. Виберіть інший.',
    mediaUploadSizeLimit: 'Кожен завантажений файл має бути не більшим за 1 ГБ.',
    serviceIdentifierMissing: 'Ідентифікатор послуги відсутній.',
    mediaUrlRequired: 'URL медіа є обовʼязковим.',
    mediaFilesRequired: 'Потрібно вибрати хоча б один файл.',
    mediaTypeRequired: 'Тип медіа обовʼязковий, якщо автоматичне визначення не спрацювало.',
    deleteAction: 'Видалити послугу',
    deleteDialogTitle: 'Видалити послугу',
    deleteDialogDescription: 'Ви впевнені, що хочете видалити {title}? Цю дію неможливо скасувати.',
    deleteDialogFallbackTitle: 'цю послугу',
    deleteDialogCancel: 'Скасувати',
    deleteDialogConfirm: 'Видалити',
    deleteInProgress: 'Видалення...',
    deleteFailed: 'Не вдалося видалити послугу. Спробуйте ще раз.',
    citiesLabel: 'Міста',
    citiesSameAsProfile: 'Як у профілі',
    citiesProfileEmpty: 'У профілі ще немає міст.',
    citiesRequired: 'Додайте принаймні одне місто або ввімкніть «Як у профілі».',
    citiesResetDialogTitle: 'Використовувати міста профілю?',
    citiesResetDialogDescription: 'Власні міста послуги буде видалено.',
    citiesResetDialogConfirm: 'Видалити міста',
  },
  home: {
    title: 'Головна',
    description:
      'Знаходьте вузькопрофільних виконавців, порівнюйте пропозиції та стежте за оновленнями платформи Matcha Events.',
    heroTitle: 'Знайдіть команду для події, яку ви полюбите.',
    heroDescription:
      'Переглядайте організаторів подій і спеціалістів, порівнюйте послуги та бронюйте впевнено.',
    ctaBrowseProfiles: 'Переглянути профілі',
    ctaBrowseServices: 'Переглянути послуги',
    ctaReadBlog: 'Читати блог',
    featuredProfiles: 'Рекомендовані профілі',
    viewAll: 'Дивитися всі',
    noProfiles:
      'Поки що немає профілів. Додайте дані в таблиці PostgreSQL `profiles` та `services`, щоб заповнити цей розділ.',
    servicesCount: 'послуг',
    fromBlog: 'З блогу',
    seeAllPosts: 'Усі пости',
    noPostsConfigured:
      'Пости блогу зʼявляться тут після налаштування `STRAPI_BASE_URL` та публікації записів у Strapi.',
    noPostsYet:
      'Strapi поки не повернув жодного поста. Опублікуйте контент у відповідній колекції, щоб заповнити цей розділ.',
    discoverNaturalLabel: 'Опишіть, що вам потрібно',
    discoverFormTitle: 'Кого ви шукаєте?',
    discoverNaturalPlaceholder:
      'Потрібен весільний фотограф у вашому місті до $500 з досвідом подієвих зйомок.',
    discoverNaturalExamples: [
      'Потрібен весільний фотограф у вашому місті до $500 з досвідом подієвих зйомок.',
      'Шукаю флориста для гала на 200 гостей.',
      'Знайдіть звукорежисера для дводенної конференції.',
    ],
    discoverNaturalSubmit: 'Знайти варіанти',
    discoverFiltersLabel: 'Уточніть фільтри',
    discoverQueryLabel: 'Пошуковий запит',
    discoverLocationLabel: 'Локація',
    discoverBudgetMinLabel: 'Мін. бюджет',
    discoverBudgetMaxLabel: 'Макс. бюджет',
    discoverCurrencyLabel: 'Валюта',
    discoverCurrencyAny: 'Будь-яка валюта',
    discoverCategoriesLabel: 'Категорії',
    discoverCategoryAny: 'Будь-яка категорія',
    discoverCategoryPlaceholder: 'Знайдіть і додайте категорії',
    discoverSkillsLabel: 'Навички',
    discoverSkillPlaceholder: 'Знайдіть і додайте навички',
    discoverAddSkill: 'Додати',
    discoverApplyFilters: 'Застосувати фільтри',
    discoverSuggestedSkills: 'Рекомендовані навички',
    discoverProfilesResults: 'Відповідні профілі',
    discoverServicesResults: 'Відповідні послуги',
    discoverNoResults: 'За поточними фільтрами збігів не знайдено.',
    discoverSearching: 'Пошук...',
    discoverSkillLoading: 'Завантаження навичок...',
    discoverSearchFailed: 'Не вдалося виконати пошук. Спробуйте ще раз.',
  },
  servicesPage: {
    navLabel: 'Мої послуги',
    title: 'Послуги',
    description: 'Переглядайте активні послуги з прозорими цінами та контекстом виконавців.',
    heroTitle: 'Переглядайте активні послуги',
    heroDescription:
      'Кожна послуга поєднує цінову модель із сутності service та контекст профілю виконавця, використовуючи картки з поточного дизайну платформи.',
    noServices:
      'Активні послуги не знайдено. Переконайтеся, що в таблиці `services` є рядки з `deleted_at IS NULL`.',
    priceModeFrom: 'Від',
    priceModeRange: 'Діапазон',
    priceModeFixed: 'Фіксована',
    viewDetails: 'Детальніше',
    adminListDescription: 'Послуги, створені в активному профілі.',
    adminCreateAction: 'Створити послугу',
    adminSearchPlaceholder: 'Пошук послуг',
    adminCountSummary: '{visible} з {total} послуг',
    adminLoading: 'Завантаження послуг...',
    adminEmpty: 'Послуг ще не знайдено.',
    adminEmptySearch: 'За вашим запитом послуг не знайдено.',
    adminAccountMissing: 'Акаунт не знайдено. Увійдіть ще раз.',
    adminProfileMissing: 'Профілів не знайдено. Спочатку створіть профіль.',
    adminEditAction: 'Редагувати послугу',
    adminSlugPending: 'Slug буде згенеровано',
    adminLoadFailed: 'Не вдалося завантажити послуги. Спробуйте ще раз.',
  },
  eventsPage: {
    navLabel: 'Події',
    title: 'Події',
    listDescription: 'Події, створені у вашому акаунті, із часом початку та завершення.',
    createAction: 'Створити подію',
    accountMissing: 'Акаунт не знайдено. Увійдіть ще раз.',
    loadFailed: 'Не вдалося завантажити події. Спробуйте ще раз.',
    loading: 'Завантаження подій...',
    empty: 'Подій ще не знайдено.',
    createDialogTitle: 'Створити подію',
    createSubmit: 'Створити',
    createSubmitting: 'Створення...',
    createFailed: 'Не вдалося створити подію. Спробуйте ще раз.',
    notFound: 'Подію не знайдено.',
    updateTitle: 'Оновити подію',
    updateDescription: 'Редагуйте деталі події на окремій сторінці.',
    updateFailed: 'Не вдалося оновити подію. Спробуйте ще раз.',
    loadingSingle: 'Завантаження події...',
    saveChanges: 'Зберегти зміни',
    saving: 'Збереження...',
    cancel: 'Скасувати',
    titlePlaceholder: 'Назва події',
    descriptionPlaceholder: 'Опис (необовʼязково)',
    cityPlaceholder: 'Місто (необовʼязково)',
    cityHelper: 'Почніть вводити місто й виберіть його з підказок Google.',
    locationPlaceholder: 'Локація / майданчик (необовʼязково)',
    locationHelper: 'Шукайте підказки для майданчика або адреси у вибраному регіоні.',
    selectCityFirst: 'Спочатку виберіть місто, щоб вказати деталі локації.',
    tableEvent: 'подія',
    tableCityLocation: 'місто / локація',
    tableStarts: 'початок',
    tableEnds: 'завершення',
    tableDescription: 'опис',
    cityLabel: 'Місто',
    locationLabel: 'Локація',
    notSpecified: 'Не вказано',
    noDescription: 'Без опису',
    unknownDate: 'Невідомо',
    positionsTitle: 'Позиції події',
    positionsDescription: 'Створюйте кадрові позиції, привʼязані до цієї події.',
    requestPosition: 'Запросити позицію',
    positionsLoading: 'Завантаження позицій...',
    positionsLoadFailed: 'Не вдалося завантажити позиції для цієї події. Спробуйте ще раз.',
    positionsEmpty: 'До цієї події ще не привʼязано позицій.',
    validationAccountMissing: 'Акаунт не знайдено. Увійдіть ще раз і спробуйте повторно.',
    validationTitleMin: 'Назва події має містити щонайменше 2 символи.',
    validationDescriptionMax: 'Опис має містити не більше 2000 символів.',
    validationCityMax: 'Назва міста має містити не більше 512 символів.',
    validationLocationMax: 'Локація має містити не більше 255 символів.',
    validationStartInvalid: 'Час початку має бути коректною датою й часом.',
    validationEndInvalid: 'Час завершення має бути коректною датою й часом.',
    validationEndAfterStart: 'Час завершення має бути пізнішим за час початку.',
  },
  positionsPage: {
    navLabel: 'Позиції',
    editTitle: 'Оновити позицію',
    editDescription: 'Редагуйте деталі позиції та керуйте статусом публікації.',
    loading: 'Завантаження позиції...',
    notFound: 'Позицію не знайдено.',
    loadFailed: 'Не вдалося завантажити позицію. Спробуйте ще раз.',
    updateFailed: 'Не вдалося оновити позицію. Спробуйте ще раз.',
    statusLabel: 'Статус',
    titlePlaceholder: 'Назва позиції',
    descriptionPlaceholder: 'Опис (необовʼязково)',
    locationPlaceholder: 'Локація (необовʼязково)',
    budgetCurrencyLabel: 'Валюта бюджету',
    budgetMinPlaceholder: 'Мінімальний бюджет (необовʼязково)',
    budgetMaxPlaceholder: 'Максимальний бюджет (необовʼязково)',
    saveChanges: 'Зберегти зміни',
    saving: 'Збереження...',
    cancel: 'Скасувати',
    publish: 'Опублікувати',
    publishing: 'Публікація...',
    publishedSuccess: 'Позицію опубліковано.',
    publishFailed: 'Не вдалося опублікувати позицію. Спробуйте ще раз.',
    close: 'Закрити',
    closing: 'Закриття...',
    closeFailed: 'Не вдалося закрити позицію. Спробуйте ще раз.',
    delete: 'Видалити',
    deleting: 'Видалення...',
    deleteConfirm: 'Видалити цю позицію? Цю дію неможливо скасувати.',
    deleteFailed: 'Не вдалося видалити позицію. Спробуйте ще раз.',
    requestDialogTitle: 'Запросити позицію',
    requestSubmit: 'Запросити',
    requestSubmitting: 'Створення...',
    requestFailed: 'Не вдалося створити позицію. Спробуйте ще раз.',
    tablePosition: 'позиція',
    tableStatus: 'статус',
    tableBudget: 'бюджет',
    tableSchedule: 'графік',
    tableSkills: 'навички',
    noBudget: 'Без бюджету',
    budgetFrom: 'Від {value}',
    budgetUpTo: 'До {value}',
    flexibleSchedule: 'Гнучко',
    noSkills: 'Без навичок',
    validationEventMissing: 'Подію не знайдено. Перезавантажте сторінку й спробуйте ще раз.',
    validationAccountMissing: 'Акаунт не знайдено. Увійдіть ще раз і спробуйте повторно.',
    validationTitleMin: 'Назва позиції має містити щонайменше 2 символи.',
    validationDescriptionMax: 'Опис має містити не більше 2000 символів.',
    validationLocationMax: 'Локація має містити не більше 128 символів.',
    validationBudgetMin: 'Мінімальний бюджет має бути числом, не меншим за 0.',
    validationBudgetMax: 'Максимальний бюджет має бути числом, не меншим за 0.',
    validationBudgetMinRequired:
      'Мінімальний бюджет обовʼязковий, якщо вказано максимальний бюджет.',
    validationBudgetRange:
      'Максимальний бюджет має бути більшим або дорівнювати мінімальному бюджету.',
    validationScheduleTogether: 'Час початку й завершення потрібно вказувати разом.',
    validationStartInvalid: 'Час початку має бути коректною датою й часом.',
    validationEndInvalid: 'Час завершення має бути коректною датою й часом.',
    validationEndAfterStart: 'Час завершення має бути пізнішим за час початку.',
  },
  proposalsPage: {
    title: 'Пропозиції',
    navLabel: 'Мої пропозиції',
    listDescription: 'Відстежуйте активні та архівні пропозиції для активного профілю.',
    activeLabel: 'Активні',
    archivedLabel: 'Архів',
    invitesFilterLabel: 'Інвайти ({count})',
    discussingFilterLabel: 'Обговорення ({count})',
    submittedFilterLabel: 'Надіслано ({count})',
    loading: 'Завантаження пропозицій...',
    loadFailed: 'Не вдалося завантажити пропозиції. Спробуйте ще раз.',
    empty: 'Пропозицій поки немає.',
    accountMissing: 'Акаунт не знайдено. Увійдіть ще раз.',
    profileMissing: 'Активний профіль не знайдено. Спочатку виберіть або створіть профіль.',
    serviceSubtitle: 'Пропозицію надіслано з послугою {serviceTitle}',
    openPositionAction: 'Відкрити позицію',
    acceptAction: 'Прийняти',
    declineAction: 'Відхилити',
    proposedPriceLabel: 'Запропонована ціна',
    acceptFailed: 'Не вдалося прийняти пропозицію. Спробуйте ще раз.',
    declineFailed: 'Не вдалося відхилити пропозицію. Спробуйте ще раз.',
    statusApproved: 'Схвалено',
    statusCanceled: 'Скасовано',
    statusDeclined: 'Відхилено',
    statusDiscussing: 'Обговорення',
    statusRejected: 'Відхилено замовником',
    statusSubmitted: 'Надіслано',
    statusViewed: 'Переглянуто',
  },
  analyticsPage: {
    navLabel: 'Дашборд',
    title: 'Аналітика',
    description:
      'Переглядайте трафік профілю, активність у matched-пошуку та взаємодії для активного профілю.',
    range7d: '7д',
    range30d: '30д',
    range90d: '90д',
    loading: 'Завантаження аналітики...',
    loadFailed: 'Не вдалося завантажити аналітику. Спробуйте ще раз.',
    profileMissing: 'Активний профіль не знайдено. Спочатку виберіть або створіть профіль.',
    noData: 'Для цього періоду аналітика ще недоступна.',
    uniqueVisitors: 'Унікальні відвідувачі',
    sessions: 'Сесії',
    profileViews: 'Перегляди профілю',
    profileIncomplete: 'Профіль не заповнено',
    contactsIncomplete: 'Контакти не заповнено',
    socialLinksIncomplete: 'Соцмережі не заповнено',
    servicesIncomplete: 'Послуги не заповнено',
    servicesListViews: 'Перегляди списку послуг',
    serviceViews: 'Перегляди послуг',
    contactClicks: 'Кліки по контактах',
    socialClicks: 'Кліки по соцмережах',
    matchedProfileImpressions: 'Покази matched-профілів',
    matchedServiceImpressions: 'Покази matched-послуг',
    matchedProfileClicks: 'Кліки по matched-профілях',
    matchedServiceClicks: 'Кліки по matched-послугах',
    totalViewsChartTitle: 'Динаміка трафіку',
    totalViewsChartDescription: 'Сумарні перегляди профілю та послуг за вибраний період.',
    topServicesTitle: 'Топ послуг',
    topCitiesTitle: 'Топ міст відвідувачів',
    serviceColumn: 'Послуга',
    cityColumn: 'Місто',
    viewsColumn: 'Перегляди',
    visitorsColumn: 'Відвідувачі',
    sessionsColumn: 'Сесії',
    matchedClicksColumn: 'Matched кліки',
  },
  profilesPage: {
    title: 'Профілі',
    description: 'Переглядайте профілі виконавців, бюджети та активні послуги на Matcha Events.',
    heading: 'Профілі',
    filteredByLocation: 'Фільтр за локацією:',
    noProfilesForLocation: 'За цим фільтром локації профілів не знайдено.',
    noProfiles:
      'Профілі не повернуто. Перевірте змінні `TYPEORM_*` та переконайтеся, що в обраній схемі є дані в profiles і services.',
    activeServices: 'активних послуг',
  },
  blogPage: {
    title: 'Блог',
    description: 'Читайте новини платформи, гайди та практичні матеріали від Matcha Events.',
    heading: 'Блог',
    missingStrapi:
      'Вкажіть `STRAPI_BASE_URL` у `apps/platform/.env.local`, щоб завантажувати контент блогу зі Strapi.',
    noPosts:
      'Strapi ще не повернув пости. Опублікуйте контент у налаштованій колекції, щоб заповнити сторінку.',
  },
  blogPostPage: {
    missingTitle: 'Статтю не знайдено',
    badge: 'Стаття блогу',
  },
  faqPage: {
    title: 'FAQ',
    description:
      'Знайдіть відповіді на поширені питання про профілі, послуги та робочі процеси платформи.',
    heading: 'Поширені запитання',
    missingStrapi:
      'Вкажіть `STRAPI_BASE_URL` у `apps/platform/.env.local`, щоб завантажувати FAQ зі Strapi.',
    noItems:
      'Strapi ще не повернув FAQ-записи. Опублікуйте елементи у вашій FAQ-колекції, щоб заповнити сторінку.',
    noAnswer: 'Відповідь поки недоступна.',
  },
  aiPage: {
    title: 'Офіційний ChatGPT-асистент',
    description:
      'Використовуйте офіційного ChatGPT-асистента Matcha Events для автентифікованого надсилання запитів і дій, повʼязаних з акаунтом.',
    badge: 'Офіційний асистент',
    heading: 'Використовуйте нашого офіційного ChatGPT-асистента',
    paragraph:
      'Для автентифікованого надсилання запитів у чаті використовуйте офіційного ChatGPT-асистента Matcha Events. Це основний сценарій асистента для дій, повʼязаних з акаунтом.',
    openAssistant: 'Відкрити офіційного ChatGPT-асистента',
    missingAssistantUrl: '`NEXT_PUBLIC_OFFICIAL_GPT_URL` ще не налаштовано.',
    quickStart: 'Швидкий старт',
    step1: 'Відкрийте офіційне посилання асистента вище.',
    step2: 'Увійдіть, коли буде запит.',
    step3: 'Надішліть свій запит безпосередньо в чаті.',
    copyPromptLabel: 'Промпт для копіювання:',
    copyPrompt:
      'Відкрий офіційного асистента Matcha Events для автентифікованого надсилання запитів.',
  },
  legalPage: {
    privacyTitle: 'Політика конфіденційності',
    privacyDescription:
      'Дізнайтеся, як Matcha Events збирає, обробляє та захищає персональні дані.',
    termsTitle: 'Умови та положення',
    termsDescription: 'Ознайомтеся з умовами використання платформи та сервісів Matcha Events.',
    missingStrapi:
      'Вкажіть `STRAPI_BASE_URL` у `apps/platform/.env.local`, щоб завантажувати юридичні сторінки зі Strapi.',
    missingPrivacy:
      'У Strapi не знайдено опублікованої сторінки Privacy Policy. Створіть запис `legal-page` зі slug `privacy-policy`.',
    missingTerms:
      'У Strapi не знайдено опублікованої сторінки Terms and Conditions. Створіть запис `legal-page` зі slug `terms-and-conditions`.',
  },
  notFoundPage: {
    heading: 'Сторінку не знайдено',
    description: 'Ресурс, який ви запитали, не існує або більше недоступний.',
    backToHome: 'На головну',
  },
  messagesPage: {
    navLabel: 'Повідомлення',
    heading: 'Повідомлення',
    subtitle: 'Розмови у вашому акаунті. Відкривайте будь-який тред і надсилайте відповіді.',
    searchPlaceholder: 'Пошук розмов',
    newChatAction: 'Новий чат',
    startChatTitle: 'Почати чат',
    startChatDescription: 'Введіть точне ім’я користувача акаунта, якому хочете написати.',
    usernameLabel: 'Ім’я користувача',
    usernamePlaceholder: 'username',
    usernameRequired: 'Введіть ім’я користувача, щоб почати чат.',
    startChatConfirm: 'Почати чат',
    startChatSubmitting: 'Створення...',
    emptyTitle: 'Розмов поки немає',
    emptyDescription: 'Почніть прямий чат, ввівши точне ім’я користувача.',
    emptyConversation: 'Виберіть розмову, щоб переглянути повідомлення.',
    noMessages: 'Повідомлень поки немає.',
    notFound: 'Розмову не знайдено.',
    accountMissing: 'Акаунт не знайдено. Увійдіть ще раз.',
    loadFailed: 'Не вдалося завантажити повідомлення. Спробуйте ще раз.',
    startChatFailed: 'Не вдалося почати чат. Спробуйте ще раз.',
    sendFailed: 'Не вдалося надіслати повідомлення. Спробуйте ще раз.',
    loadingConversations: 'Завантаження розмов...',
    loadingMessages: 'Завантаження повідомлень...',
    messagePlaceholder: 'Напишіть повідомлення...',
    sendAction: 'Надіслати',
    sending: 'Надсилання...',
    directConversationSubtitle: '{name}',
    positionConversationSubtitle: 'Чат по позиції з {name}',
    eventConversationSubtitle: 'Чат по події з {name}',
    unknownParticipant: 'Невідомий користувач',
    typeDirect: 'Прямий',
    typePosition: 'Позиція',
    typeEvent: 'Подія',
    createdAtLabel: 'Оновлено {date}',
  },
  galleriesPage: {
    navLabel: 'Галереї',
    title: 'Галереї',
    loading: 'Завантажуємо галереї...',
    loadFailed: 'Не вдалося завантажити галереї. Спробуйте ще раз.',
    notFound: 'Галерею не знайдено. Можливо, її видалено.',
    profileMissing: 'Профіль не знайдено. Спершу створіть профіль.',
    newGallery: '+ Нова галерея',
    creating: 'Створюємо...',
    untitled: 'Галерея без назви',
    noDate: 'Без дати',
    fileCount: {
      one: '{count} файл',
      few: '{count} файли',
      many: '{count} файлів',
      other: '{count} файлу',
    },
    status: {
      ACTIVE: 'Активна',
      SELECTION_SENT: 'Вибір надіслано',
      EXPIRED: 'Термін минув',
    },
    banner: {
      text: {
        one: '♥ «{title}»: гості надіслали вибір — {count} файл',
        few: '♥ «{title}»: гості надіслали вибір — {count} файли',
        many: '♥ «{title}»: гості надіслали вибір — {count} файлів',
        other: '♥ «{title}»: гості надіслали вибір — {count} файлу',
      },
      view: 'Переглянути',
      close: 'Закрити',
    },
    counters: {
      views: 'Перегляди',
      downloads: 'Завантажено файлів',
      zips: 'ZIP-архівів',
      favorites: 'Фаворитів',
      selected: 'Вибрано',
    },
    settingsButton: 'Налаштування',
    share: {
      title: 'Поділитися',
      linkLabel: 'Посилання на галерею',
      noLink: 'Посилання з’явиться, щойно у профілю буде адреса сайту.',
      copyForClient: 'Скопіювати для клієнта',
      copied: 'Скопійовано: вставте в повідомлення клієнту',
      copyFailed: 'Не вдалося скопіювати. Виділіть текст і скопіюйте вручну.',
      openAsGuest: 'Відкрити як гість',
      reissue: 'Перевипустити посилання',
      reissueTitle: 'Перевипустити посилання?',
      reissueBody: 'Старе посилання перестане працювати одразу. Вибір, коментарі й лічильники збережуться. Нове посилання треба буде надіслати клієнту.',
      reissueConfirm: 'Перевипустити',
      reissued: 'Нове посилання готове',
      password: 'Пароль: {password}',
      passwordHint: 'Надішліть його разом із посиланням або окремо.',
      noPassword: 'Без пароля: галерею відкриє кожен, хто має посилання.',
      newPassword: 'Новий пароль',
      newPasswordDone: 'Новий пароль готовий: надішліть його клієнту',
      linkTemplate: '{title}: {link}',
      passwordTemplate: 'Пароль: {password}',
    },
    files: {
      allFiles: 'Усі файли',
      selectionTab: '♥ Вибір ({count})',
      sectionUnnamed: 'Розділ без назви',
      sectionsLabel: 'Розділи',
      addSectionPlaceholder: 'Новий розділ',
      addSection: '+ Розділ',
      renameSection: 'Перейменувати',
      renameSectionTitle: 'Перейменувати розділ',
      sectionNameLabel: 'Назва розділу',
      save: 'Зберегти',
      deleteSection: 'Видалити розділ',
      deleteSectionTitle: 'Видалити «{name}»?',
      deleteSectionBody: {
        one: 'Розділ і його {count} файл буде видалено безповоротно.',
        few: 'Розділ і його {count} файли буде видалено безповоротно.',
        many: 'Розділ і його {count} файлів буде видалено безповоротно.',
        other: 'Розділ і його {count} файлу буде видалено безповоротно.',
      },
      empty: 'Файлів поки немає. Перетягніть фото й відео вище.',
      emptySection: 'У цьому розділі поки немає файлів.',
      dropTitle: 'Перетягніть сюди фото й відео',
      dropHint: 'Або натисніть, щоб вибрати. Сотні файлів за раз: фото до 50 МБ, відео до 1 ГБ і 10 хвилин (MP4 або MOV, H.264).',
      uploading: 'Завантаження {done} з {total}',
      uploaded: 'Завантажено {done} з {total}',
      notAccepted: {
        one: 'Не прийнято {count} файл',
        few: 'Не прийнято {count} файли',
        many: 'Не прийнято {count} файлів',
        other: 'Не прийнято {count} файлу',
      },
      clearUploads: 'Очистити',
      processing: 'Обробляємо...',
      processingFailed: 'Прев’ю не створено',
      video: 'Відео',
      cover: 'Обкладинка',
      makeCover: 'Зробити обкладинкою',
      moveTo: 'Перенести в «{name}»',
      deleteFile: 'Видалити',
      deleteFileTitle: 'Видалити цей файл?',
      deleteFileBody: '«{name}» буде видалено безповоротно разом із позначкою вибору й коментарями.',
      fileActions: 'Дії з файлом',
      hidden: 'Приховано гостем',
      restore: 'Повернути гостям',
      restored: 'Гості знову його бачать',
      dragHint: 'Перетягуйте файли, щоб змінити порядок у розділі.',
    },
    uploadErrors: {
      FILE_TYPE: 'Не фото і не відео MP4/MOV',
      PHOTO_TOO_LARGE: 'Фото більше 50 МБ',
      VIDEO_TOO_LARGE: 'Відео більше 1 ГБ',
      GALLERY_VIDEO_TOO_LONG: 'Відео довше за 10 хвилин',
      GALLERY_VIDEO_NOT_H264: 'Відео не в H.264 (на iPhone виберіть «Найсумісніший»)',
      GALLERY_VIDEO_UNREADABLE: 'Не вдалося прочитати відео',
      STORAGE_LIMIT_EXCEEDED: 'Сховище заповнене',
      FAILED: 'Не вдалося завантажити',
    },
    selection: {
      heading: 'Вибір гостей: {count}',
      headingWithLimit: 'Вибір гостей: {count} / {limit}',
      sentAt: 'Надіслано {date}',
      notSent: 'Ще не надіслано: гості обирають',
      copyNames: 'Скопіювати імена файлів',
      namesCopied: 'Імена файлів скопійовано: вставте їх у пошук Lightroom',
      unlock: 'Розблокувати вибір',
      unlocked: 'Вибір розблоковано: гості можуть його змінювати',
      empty: 'Гості ще нічого не вибрали.',
      anonymous: 'без імені',
    },
    settings: {
      title: 'Налаштування',
      titleLabel: 'Назва',
      titlePlaceholder: 'Наприклад, Олена і Максим',
      shootDateLabel: 'Дата зйомки',
      styles: {
        COVER: 'Обкладинка',
        EDITORIAL: 'Редакційний',
        COMPACT: 'Компактний',
      },
      layouts: {
        GRID: 'Сітка',
        MASONRY: 'Мозаїка',
        SLIDESHOW: 'Слайдшоу',
      },
      access: 'Доступ',
      passwordLabel: 'Пароль',
      passwordPlaceholder: 'Без пароля',
      passwordInvalid: 'Пароль має бути щонайменше з 4 символів.',
      expiresLabel: 'Доступ до (необов’язково)',
      expiresHint: 'Після цієї дати галерея ховається, файли лишаються.',
      expiresClear: 'Прибрати дату',
      expiryLockedHint: 'Входить у план Pro. Уже вибрані дата чи видалення діють і далі, їх можна прибрати. Pro купують у застосунку Matcha, у розділі «Моя підписка».',
      autoDeleteLabel: 'Видалити файли після терміну',
      autoDelete: {
        OFF: 'Не видаляти',
        NOW: 'Одразу після терміну',
        AFTER_30_DAYS: 'Через 30 днів',
        AFTER_90_DAYS: 'Через 90 днів',
      },
      autoDeleteHint: 'Безповоротно. За 7 днів прийде push: можна скасувати або продовжити.',
      autoDeleteNeedsExpiry: 'Спершу вкажіть дату доступу.',
      guests: 'Що можуть гості',
      downloadsLabel: 'Завантаження',
      downloads: {
        ALL: 'Оригінали і web-розмір',
        WEB: 'Тільки web-розмір (2048 px)',
        ORIGINAL: 'Тільки оригінали',
        OFF: 'Вимкнено',
      },
      languageLabel: 'Мова галереї',
      languages: {
        SITE: 'Як на сайті',
        uk: 'Українська',
        en: 'English',
        ru: 'Русский',
      },
      languageHint: 'Кнопки, підказки й екран пароля для гостей. Ваші назви й підписи лишаються як є.',
      guestHintsLabel: 'Підказки для гостей',
      guestHintsSwitch: 'Показувати гостям підказки',
      guestHintsHint: 'Короткі кроки, які гості бачать один раз на кожному пристрої після пароля: як вибирати, надсилати й завантажувати.',
      allowHidingLabel: 'Приховані фото',
      allowHidingSwitch: 'Гості можуть приховувати фото',
      allowHidingHint: 'Гість може приховати фото чи відео для всіх, хто має посилання. Ви й далі бачите його тут із позначкою і можете повернути.',
      watermarkLabel: 'Водяний знак',
      watermarkSwitch: 'Показувати гостям мій водяний знак',
      watermarkHint: 'Гості бачать і завантажують фото веброзміру з вашим водяним знаком. Відео й обкладинка лишаються без нього.',
      watermarkOriginalsHint: 'Оригінали завантажуються без водяного знака.',
      watermarkEdit: 'Вигляд водяного знака',
      selectionLimitLabel: 'Ліміт вибору (порожньо — без ліміту)',
      selectionLimitInvalid: 'Ліміт вибору — ціле число від 1.',
      done: 'Готово',
      saving: 'Зберігаємо...',
      saved: 'Налаштування збережено',
      deleteGallery: 'Видалити галерею',
      deleteTitle: 'Видалити «{title}»?',
      deleteBody: {
        one: '{count} файл, вибір і коментарі буде видалено безповоротно. Посилання перестане працювати.',
        few: 'Усі {count} файли, вибір і коментарі буде видалено безповоротно. Посилання перестане працювати.',
        many: 'Усі {count} файлів, вибір і коментарі буде видалено безповоротно. Посилання перестане працювати.',
        other: 'Усі {count} файлу, вибір і коментарі буде видалено безповоротно. Посилання перестане працювати.',
      },
      deleteConfirm: 'Видалити',
      deleted: 'Галерею видалено',
    },
    errors: {
      actionFailed: 'Не вдалося зберегти зміну. Спробуйте ще раз.',
      GALLERY_PROVIDER_ONLY: 'Галереї можуть бути лише в профілю виконавця.',
      GALLERY_LIMIT_REACHED: 'На вашому плані більше немає місця для галерей. Видаліть ту, що вже не потрібна; у плані Pro обмежень немає.',
      GALLERY_TITLE_TOO_LONG: 'Назва задовга.',
      GALLERY_SHOOT_DATE_INVALID: 'Неправильна дата зйомки.',
      GALLERY_SELECTION_LIMIT_INVALID: 'Ліміт вибору — ціле число від 1.',
      GALLERY_LAST_SECTION: 'У галереї лишається щонайменше один розділ.',
      GALLERY_COVER_NOT_PHOTO: 'Обкладинкою може бути лише фото.',
      GALLERY_PLAN_REQUIRED: 'Це налаштування входить у план Pro. Pro купують у застосунку Matcha, у розділі «Моя підписка».',
      GALLERY_WATERMARK_LOGO_REQUIRED: 'Спершу завантажте логотип PNG, а тоді виберіть його як водяний знак.',
      GALLERY_WATERMARK_TEXT_TOO_LONG: 'Текст водяного знака задовгий.',
    },
    watermark: {
      title: 'Водяний знак',
      locked: 'Водяний знак входить у план Pro. Тут його можна переглянути, а змінити — з планом Pro; Pro купують у застосунку Matcha.',
      loadFailed: 'Не вдалося завантажити водяний знак.',
      preview: 'Попередній перегляд водяного знака',
      previewHint: 'Приблизно. Справжній знак підбирається під розмір кожного фото.',
      kindLabel: 'Знак',
      kinds: {
        TEXT: 'Текст',
        LOGO: 'Логотип',
      },
      textLabel: 'Текст',
      textPlaceholder: 'Ваше ім’я чи студія',
      textHint: 'Залиште порожнім, щоб показувати ім’я профілю.',
      logoLabel: 'Логотип',
      logoHint: 'Файл PNG до 5 МБ. Найкраще виглядає прозорий фон.',
      storedLogoHint: 'Логотип збережено, але він не використовується. Видаліть його, щоб звільнити місце.',
      noLogo: 'Логотипа ще немає',
      chooseLogo: 'Вибрати PNG',
      replaceLogo: 'Замінити логотип',
      removeLogo: 'Видалити логотип',
      removeLogoTitle: 'Видалити логотип?',
      removeLogoBody: 'Файл буде видалено, а водяний знак знову стане текстом.',
      removeLogoConfirm: 'Видалити',
      uploading: 'Завантаження...',
      logoUploaded: 'Логотип додано',
      logoRemoved: 'Логотип видалено',
      logoErrors: {
        notPng: 'Логотип має бути файлом PNG.',
        tooLarge: 'Логотип може бути до 5 МБ.',
        STORAGE_LIMIT_EXCEEDED: 'У сховищі не лишилося місця.',
        FAILED: 'Не вдалося завантажити логотип. Спробуйте ще раз.',
      },
      positionLabel: 'Розташування',
      positions: {
        CENTER: 'По центру',
        BOTTOM_RIGHT: 'У куті',
        TILED: 'Візерунком',
      },
      strengthLabel: 'Насиченість',
      strengths: {
        LIGHT: 'Легка',
        MEDIUM: 'Середня',
        STRONG: 'Сильна',
      },
      appliesHint: 'Показується на фото веброзміру в галереях, де увімкнено водяний знак. Оригінали, відео й обкладинка лишаються без нього.',
      saved: 'Водяний знак збережено',
      done: 'Готово',
      saving: 'Збереження...',
    },
    design: {
      open: 'Дизайн',
      back: 'Файли',
      title: 'Дизайн',
      intro: 'Кожна зміна зберігається одразу, і гості бачать її відразу.',
      saving: 'Зберігаємо...',
      coverLabel: 'Обкладинка',
      coverNone: 'Обкладинки ще немає',
      coverUploaded: 'Завантажена обкладинка',
      coverPicked: 'Фото з галереї',
      coverPreparing: 'Готуємо обкладинку...',
      coverUpload: 'Завантажити JPG або PNG',
      coverUploading: 'Завантаження...',
      coverUploadedDone: 'Обкладинку завантажено',
      coverPickLabel: 'Або виберіть фото з галереї',
      coverPickItem: 'Зробити {name} обкладинкою',
      coverEmpty: 'Завантажте фото, щоб вибрати з них обкладинку.',
      coverHint: 'Завантажена обкладинка не є файлом галереї: її немає в завантаженнях і на ній ніколи немає водяного знака.',
      coverErrors: {
        fileType: 'Обкладинкою може бути лише фото JPG або PNG.',
        tooLarge: 'Обкладинка може бути до 50 МБ.',
        STORAGE_LIMIT_EXCEEDED: 'У вашому сховищі не вистачає місця.',
        FAILED: 'Не вдалося завантажити обкладинку. Спробуйте ще раз.',
      },
      styleLabel: 'Стиль сторінки',
      layoutLabel: 'Розкладка фото',
      lookHint: 'Шрифти й кольори беруться з дизайну вашого сайту.',
      spacingLabel: 'Відступи між фото',
      spacings: {
        DESIGN: 'Як у дизайні',
        SMALLER: 'Менші',
        LARGER: 'Більші',
        NONE: 'Без відступів',
      },
      shapeLabel: 'Форма фото',
      shapes: {
        SQUARE: 'Квадрат',
        ORIGINAL: 'Оригінальна',
        PORTRAIT: 'Вертикальна 4:5',
        LANDSCAPE: 'Горизонтальна 3:2',
      },
      watermarkProgress: 'Водяний знак: готово {ready}/{total}',
      watermarkFailed: 'Не вдалося зробити: {count}',
      previewLabel: 'Попередній перегляд',
      previewFrameTitle: 'Галерея так, як її бачать гості',
      previewHint: 'Перегляд показує збережену галерею й оновлюється після кожної зміни.',
      desktop: 'Комп’ютер',
      phone: 'Телефон',
    },
    plan: {
      badge: 'Pro',
      lockedHint: 'Входить у план Pro. Pro купують у застосунку Matcha, у розділі «Моя підписка».',
    },
    cancel: 'Скасувати',
  },
  reviewsPage: {
    navLabel: 'Відгуки',
    title: 'Відгуки',
    tabReports: 'Скарги · {count}',
    tabAll: 'Усі відгуки',
    tabHidden: 'Сховані',
    starsLabel: 'Оцінка',
    starsAll: 'Усі оцінки',
    starsOption: '{stars} ★',
    profileFilter: 'Профіль: {profile}',
    clearProfileFilter: 'Прибрати фільтр за профілем',
    filterByProfile: 'Показати відгуки цього профілю',
    filtersUnavailableForReports: 'Фільтри діють для вкладок «Усі відгуки» і «Сховані».',
    profileFallback: 'Непублічний профіль',
    columnProfile: 'Профіль',
    columnStars: '★',
    columnReview: 'Відгук і відповідь',
    columnChannel: 'Канал',
    columnReport: 'Скарга',
    columnActions: 'Дії',
    replyLabel: 'Відповідь: {reply}',
    replyNone: 'немає',
    channelLink: 'Посилання для відгуку',
    channelEmail: 'Email-код',
    reportOpen: 'Відкрита з {date}',
    reportRejected: 'Відхилена {date}',
    reportUpheld: 'Задоволена {date}',
    reportNone: '—',
    reportMessage: 'Примітка виконавця: {message}',
    hiddenStatus: 'Сховано: {reason}',
    hideAction: 'Сховати',
    rejectReportAction: 'Відхилити скаргу',
    hideDialogTitle: 'Сховати відгук {author}?',
    hideDialogDescription: 'Відгук зникне з усіх сторінок і з рейтингу. Виконавець побачить причину.',
    reasonLabel: 'Причина',
    reasonSpam: 'Спам',
    reasonAbuse: 'Образа',
    reasonFake: 'Фейк',
    reasonNotAboutProvider: 'Не про цього виконавця',
    cancel: 'Скасувати',
    loading: 'Завантаження відгуків...',
    loadFailed: 'Не вдалося завантажити відгуки. Спробуйте ще раз.',
    emptyReports: 'Відкритих скарг немає.',
    emptyReviews: 'Відгуків не знайдено.',
    forbidden: 'Цей розділ доступний лише модераторам Matcha.',
    hidden: 'Відгук сховано.',
    reportRejectedSuccess: 'Скаргу відхилено.',
    hideFailed: 'Не вдалося сховати відгук. Спробуйте ще раз.',
    rejectFailed: 'Не вдалося відхилити скаргу. Спробуйте ще раз.',
    loadMore: 'Показати ще',
  },
  chatPage: {
    defaultGreeting:
      'Привіт, я {assistantName} - AI-асистент, який допомагає планувати події та знаходити виконавців послуг. Я можу допомогти знайти фотографа, ведучого події чи іншого виконавця, а також конкретні послуги. Опишіть, що вам потрібно, наприклад: "Потрібен фотограф на весілля в пʼятницю о 18:00, місто: {city}, бюджет до $500."',
    dynamicCapabilitiesIntro: 'З огляду на доступні зараз інструменти, я можу допомогти з',
    dynamicCapabilitiesFallback:
      'Я все одно можу допомогти спланувати подію простою мовою і підказати наступні кроки.',
    dynamicCapabilityEvents: 'плануванням та оновленням подій',
    dynamicCapabilityPositions: 'створенням і керуванням позиціями',
    dynamicCapabilityProviders: 'пошуком виконавців і послуг',
    dynamicCapabilitySkills: 'підбором потрібних навичок',
    dynamicCapabilitySummaries: 'зведеннями та статусами подій',
    sendError: 'Не вдалося надіслати повідомлення.',
    fallbackAssistantReply:
      'Я не зміг виконати цей запит. Переформулюйте його та спробуйте ще раз.',
    authRequiredHeading: 'Потрібна автентифікація',
    authRequiredDescription: 'Увійдіть, щоб отримати доступ до чату.',
    authRequiredBanner: 'Чат доступний лише для автентифікованих користувачів.',
    authAction: 'Увійти / Зареєструватися',
    heading: 'Чат',
    subtitle: 'Спілкуйтеся з {assistantName}, щоб планувати події звичайною мовою.',
    you: 'Ви',
    thinking: 'Думаю...',
    messageLabel: 'Повідомлення',
    messagePlaceholder: 'Повідомлення для {assistantName}...',
    composerHint: 'Enter для надсилання, Shift+Enter для нового рядка.',
    send: 'Надіслати',
  },
  serviceDetailsPage: {
    missingTitle: 'Послугу не знайдено',
    titleSuffix: 'Послуги Matcha Events',
    priceModeFrom: 'Ціна від',
    priceModeRange: 'Діапазон цін',
    priceModeFixed: 'Фіксована ціна',
    backToServices: 'Назад до послуг',
    viewProfile: 'Переглянути профіль',
    aboutProvider: 'Про цього виконавця',
    providerDescriptionFallback: 'Цей виконавець ще не додав опис профілю.',
    moreServices: 'Більше послуг від {displayName}',
    browseAllServices: 'Переглянути всі послуги',
  },
  profileDetailsPage: {
    storageUsageTemplate: 'Сховище: {used} / {limit} ГБ',
    storageUsageUnlimitedTemplate: 'Сховище: {used} ГБ',
    missingTitle: 'Профіль не знайдено',
    backToProfiles: 'Назад до профілів',
    servicesLabel: 'Послуги',
    typicalBudgetRange: 'Діапазон бюджету:',
    locations: 'Локації:',
    languages: 'Мови:',
    latestServices: 'Ознайомтеся з моїми останніми послугами',
    showAllServices: 'Показати всі послуги {fullName}',
    noServices: 'У цього профілю ще немає активних послуг.',
    viewService: 'Переглянути послугу',
    openService: 'Відкрити послугу',
    moreServicesAvailable: 'додаткових послуг доступно',
    contactPhone: 'Телефон',
    contactEmail: 'Email',
    contactOther: 'Інше',
    socialTwitter: 'Twitter/X',
    socialInstagram: 'Instagram',
    socialThreads: 'Threads',
    socialFacebook: 'Facebook',
    socialTikTok: 'TikTok',
    socialYouTube: 'YouTube',
    socialWebsite: 'Вебсайт',
    socialOther: 'Інше',
  },
  profileServicesPage: {
    missingTitle: 'Послуги профілю не знайдено',
    title: 'Послуги {displayName}',
    description: 'Переглядайте всі активні послуги, які пропонує {displayName} на Matcha Events.',
    heading: 'Послуги {displayName}',
    backToProfile: 'Назад до профілю',
    noServices: 'У цього профілю ще немає активних послуг.',
  },
  positionDetailsPage: {
    missingTitle: 'Позицію не знайдено',
    titleSuffix: 'Позиції Matcha Events',
    badge: 'Доступна позиція',
  },
  subscriptionPage: {
    navLabel: 'Підписка',
    title: 'Моя підписка',
    loading: 'Завантажуємо підписку...',
    loadFailed: 'Не вдалося завантажити підписку. Спробуйте ще раз.',
    current: 'Ваша підписка',
    names: { free: 'Free', pro: 'Pro' },
    compare: {
      storage: { label: 'Сховище', free: '1 ГБ', pro: '5 ГБ' },
      galleries: { label: 'Галереї для клієнтів', free: 'до 3', pro: 'без ліміту' },
      gallerySettings: { label: 'Водяний знак, строк доступу, ліміт вибору', free: '—', pro: '✓' },
      webDownloads: { label: 'Завантаження web-розміру', free: '—', pro: '✓' },
      matchaMark: { label: 'Галерея без позначки Matcha', free: '—', pro: '✓' },
      ownAssistant: { label: 'Свій ШІ-асистент для сайту', free: '—', pro: '✓' },
    },
    getProTitle: 'Pro оформлюють у застосунку Matcha',
    getProBody: 'Відкрийте «Моя підписка» в застосунку: перші 7 днів безкоштовно, далі щомісяця. Після оформлення Pro діє і тут.',
    appStore: 'App Store',
    googlePlay: 'Google Play',
    status: {
      trial: 'Безкоштовний тиждень до {{date}}',
      renews: 'Поновиться {{date}}',
      ends: 'Скасовано. Pro діє до {{date}}',
    },
    manage: {
      APP_STORE: 'Оформлено в App Store. Керувати чи скасувати можна на iPhone: Налаштування → ваше ім’я → Підписки.',
      PLAY_STORE: 'Оформлено в Google Play. Керувати чи скасувати можна в Google Play → Платежі й підписки.',
      INTERNAL: 'Pro надано командою Matcha.',
    },
  },
  sitePage: {
    navLabel: 'Мій сайт',
    title: 'Мій сайт',
    status: {
      create: 'Створити',
      draft: 'Чернетка',
      published: 'Опубліковано',
      disabled: 'Вимкнено',
    },
    publishedVersion: 'Опубліковано · версія {version}',
    notPublished: 'Ще не опубліковано',
    disabledStatus: 'Вимкнено: відвідувачі не бачать сайт',
    open: 'Відкрити',
    share: 'Поділитися',
    draft: {
      title: 'Є неопубліковані зміни',
      message: 'Відвідувачі бачать попередню версію.',
      firstMessage: 'Перегляньте чернетку й опублікуйте сайт.',
      preview: 'Переглянути',
      publish: 'Опублікувати',
      published: 'Сайт опубліковано',
      publishedMessage: 'Відвідувачі вже бачать нову версію.',
      discard: 'Скасувати зміни',
      discarded: 'Зміни скасовано',
      discardSheet: {
        title: 'Скасувати зміни?',
        message: 'Чернетку буде видалено, сайт лишиться таким, як опубліковано.',
        confirm: 'Скасувати зміни',
        keep: 'Залишити',
      },
    },
    changeDesign: 'Змінити дизайн',
    remainingEdits: 'Правок на сьогодні: {count}',
    remainingBuilds: 'Створень сайту на сьогодні: {count}',
    versions: {
      title: 'Версії',
      version: 'Версія {number}',
      current: 'на сайті',
      restore: 'Повернути',
      hint: '«Повернути» кладе версію в чернетку. На сайт вона потрапить, коли ви її опублікуєте.',
      restored: 'Версію {number} повернуто в чернетку',
      restoredMessage: 'Перегляньте чернетку й опублікуйте, коли будете готові.',
    },
    language: {
      title: 'Мова сайту',
      hint: 'Мова кнопок, розділів і підписів на сайті. Ваші тексти з профілю лишаються як є.',
      options: {
        uk: 'Українська',
        en: 'English',
        ru: 'Русский',
      },
    },
    disable: 'Вимкнути сайт',
    enable: 'Увімкнути сайт',
    disableConfirmTitle: 'Вимкнути сайт?',
    disableConfirmMessage: 'Відвідувачі перестануть його бачити. Увімкнути можна будь-коли, версії залишаться.',
    empty: {
      heading: 'Власний сайт із вашого профілю',
      body: 'Опишіть, яким бачите сайт, і AI-дизайнер його зробить. Тексти, ціни, фото й контакти беруться з профілю, тож сайт оновлюється сам, коли ви змінюєте профіль.',
      examplesTitle: 'Наприклад',
      examples: {
        example1: 'Темний і стильний, як нічний клуб, з неоновими акцентами',
        example2: 'Світлий і ніжний, для весіль, багато повітря й фото',
        example3: 'Як сайт, що мені подобається (посилання), але в моїх кольорах',
        example4: 'Яскравий і сміливий: великі літери, багато кольору',
        example5: 'Мінімалістичний і строгий, як у дизайн-студії',
        example6: 'Теплий і затишний, землисті кольори, відчуття ручної роботи',
        example7: 'Як глянцевий журнал: великі фото й красиві заголовки',
        example8: 'Ретро в стилі 70-х, теплі кольори й округлі шрифти',
        example9: 'Сучасний і технологічний: темний фон, чіткі лінії',
        example10: 'Романтичний, пастельні кольори, м’які форми',
        example11: 'Преміальний: багато простору, тонкі лінії, стримана палітра',
        example12: 'Грайливий і веселий, для дитячих свят і вечірок',
      },
      inputLabel: 'Яким має бути сайт?',
      placeholder: 'Стиль, настрій, кольори. Можна дати посилання на сайт, який подобається.',
      create: 'Створити сайт',
      hint: 'Займає 2–3 хвилини. Пришлемо сповіщення, коли буде готово.',
    },
    assistant: {
      title: 'Редагуйте сайт у своєму Claude',
      body: 'Якщо у вас є Claude, він може змінювати дизайн цього сайту. Ці правки не витрачають денний ліміт.',
      connect: 'Підключити Claude',
      connected: '{client} підключено',
      lastUsed: 'Остання правка {date}',
      neverUsed: 'Ще не робив правок',
      disconnect: 'Відключити',
      disconnectConfirmTitle: 'Відключити {client}?',
      disconnectConfirmMessage: '{client} більше не зможе змінювати ваш сайт. Підключити знову можна будь-коли.',
      disconnected: '{client} відключено',
      disconnectClient: 'Відключити {client}',
      changeTitle: 'Змінюйте дизайн у своєму Claude',
      changeBody: 'Підключіть Claude, яким уже користуєтесь: він змінить кольори, шрифти й блоки сайту. Ваші дані на сайті беруться з профілю.',
      locked: {
        title: 'Свій ШІ-асистент',
        body: 'Змінюйте сайт розмовою зі своїм Claude чи ChatGPT. Доступно в плані Pro.',
      },
      createWithClaude: 'Створити сайт з Claude',
      changeWithClaude: 'Змінити дизайн з Claude',
      prompt: {
        create: 'Створи мені сайт на Matcha. Подивись мій профіль і запропонуй дизайн.',
        change: 'Зміни дизайн мого сайту на Matcha ({site}). Спершу подивись, який він зараз, і запитай, що змінити.',
      },
      create: {
        title: 'Створіть сайт у своєму Claude',
        body: 'Підключіть Claude, яким уже користуєтесь, і він зробить сайт з вашого профілю: послуги, ціни, фото й контакти підтягнуться самі.',
        steps: {
          connect: 'Підключіть Claude і підтвердьте тут',
          create: 'Натисніть «Створити сайт з Claude» і надішліть готовий запит',
          publish: 'Claude покаже прев’ю, а опублікує, коли ви скажете',
        },
        note: 'Потрібен свій Claude (claude.ai). Matcha за нього не платить і нічого не списує.',
      },
      request: {
        title: 'Дозволити {client} редагувати ваш сайт?',
        can: 'Змінювати дизайн чернетки й публікувати її, коли ви попросите',
        cannot: 'Не зможе змінювати профіль, послуги, ціни й фото або вимкнути сайт',
        note: 'Запит з вашого посилання «Підключити Claude». Якщо ви його не робили, відхиліть.',
        allow: 'Дозволити',
        deny: 'Відхилити',
        allowedTitle: '{client} підключено',
        allowedMessage: 'Повертайтеся в {client} і попросіть змінити сайт. Відключити можна на сторінці «Мій сайт».',
        deniedTitle: 'Відхилено',
        deniedMessage: '{client} не отримав доступу до вашого сайту.',
        done: 'Готово',
        close: 'Закрити',
        none: 'Цей запит уже завершився.',
      },
    },
    chat: {
      title: 'Дизайнер сайту',
      subtitle: 'Змінює лише дизайн',
      intro: 'Напишіть, що змінити на сайті: кольори, шрифти, блоки, настрій. Можна дати посилання на сайт-приклад.',
      working: 'Дизайнер працює…',
      steps: {
        reading: 'Дивлюся сайт і профіль',
        designing: 'Змінюю дизайн',
        checking: 'Перевіряю сторінки',
      },
      closeHint: 'Можна закрити сторінку: пришлемо сповіщення в застосунок.',
      previewDraft: 'Переглянути чернетку',
      placeholder: 'Що змінити на сайті?',
      waitingPlaceholder: 'Зачекайте, поки дизайнер закінчить',
      inputLabel: 'Повідомлення дизайнеру',
      send: 'Надіслати',
      limitReached: 'На сьогодні ліміт вичерпано. Нові спроби з’являться опівночі за Києвом.',
    },
    designs: {
      section: 'Дизайн',
      title: 'Готові дизайни',
      startBody: 'Оберіть готовий дизайн, і сайт буде готовий за хвилину. Тексти, ціни, фото й контакти беруться з профілю, тож сайт оновлюється сам, коли ви змінюєте профіль.',
      choose: 'Обрати готовий дизайн',
      startCount: {
        one: '{count} дизайн. Спершу ті, що для ваших категорій.',
        few: '{count} дизайни. Спершу ті, що для ваших категорій.',
        many: '{count} дизайнів. Спершу ті, що для ваших категорій.',
        other: '{count} дизайну. Спершу ті, що для ваших категорій.',
      },
      aiTitle: 'Опишіть сайт AI-дизайнеру',
      aiBody: 'Розкажіть про стиль, настрій і кольори, і він зробить дизайн за 2–3 хвилини.',
      aiAction: 'Описати свій сайт',
      rowCurrent: 'Поточний: {name} · усього {count}',
      rowCount: {
        one: '{count} дизайн на вибір',
        few: '{count} дизайни на вибір',
        many: '{count} дизайнів на вибір',
        other: '{count} дизайну на вибір',
      },
      versionSummary: 'Готовий дизайн «{name}»',
      all: 'Усі',
      seeAll: 'Усі {count} ›',
      hint: 'Натисніть на дизайн, щоб побачити його на своїх даних.',
      otherGroups: 'Інші групи',
      current: 'Поточний',
      viewLabel: 'Показати дизайн на',
      viewDesktop: 'Комп’ютер',
      viewMobile: 'Телефон',
      groupsLabel: 'Групи дизайнів',
      tileLabel: 'Дизайн {name}',
      groups: {
        universal: 'Універсальні',
        'photo-video': 'Фото й відео',
        'hosts-shows': 'Ведучі й шоу',
        music: 'Музика',
        'decor-floristry': 'Декор і флористика',
        'food-sweets': 'Кухня й солодке',
        venues: 'Локації',
        'wedding-fashion': 'Весільна мода',
        beauty: 'Краса',
        'tech-effects': 'Техніка й ефекти',
        'ceremony-planning': 'Церемонія й організація',
        transport: 'Транспорт',
        printing: 'Поліграфія',
      },
      universalDesign: 'Універсальний дизайн',
      tryOnMyData: 'Переглянути на моїх даних',
      apply: 'Застосувати',
      applyHint: 'Дизайн замінить чернетку. Відвідувачі побачать його, коли ви опублікуєте сайт.',
      replace: {
        title: 'Замінити чернетку?',
        message: 'У чернетці є неопубліковані зміни. Дизайн «{name}» замінить їх.',
        versionsKept: 'Опубліковані версії залишаться, і будь-яку з них можна повернути.',
        confirm: 'Замінити чернетку',
      },
      applied: 'Дизайн «{name}» у чернетці',
      loadFailed: 'Не вдалося завантажити дизайни',
      retry: 'Спробувати ще раз',
      errors: {
        previewFailedTitle: 'Не вдалося відкрити перегляд',
        applyFailedTitle: 'Не вдалося застосувати дизайн',
      },
    },
    errors: {
      loadFailedTitle: 'Не вдалося завантажити сайт',
      sendFailedTitle: 'Не вдалося надіслати повідомлення',
      publishFailedTitle: 'Не вдалося опублікувати сайт',
      restoreFailedTitle: 'Не вдалося повернути версію',
      discardFailedTitle: 'Не вдалося скасувати зміни',
      disableFailedTitle: 'Не вдалося змінити стан сайту',
      languageFailedTitle: 'Не вдалося змінити мову сайту',
      tryAgain: 'Спробуйте ще раз.',
    },
    linkCopied: 'Посилання скопійовано',
    profileMissing: 'Профілі не знайдено. Спочатку створіть профіль.',
    back: 'Назад',
    cancel: 'Скасувати',
    or: 'або',
  },
};
